export type SortModel = {
  field: string
  sort: 'asc' | 'desc'
}

export const DEFAULT_SORT_MODEL: SortModel = { field: 'createdAt', sort: 'desc' }

const CARD_TOP_SLICE = 4

export const sortAndSliceRows = <T extends Record<string, unknown>>(
  rows: T[],
  sortModel: SortModel = DEFAULT_SORT_MODEL,
  limit: number = CARD_TOP_SLICE
): T[] => {
  const { field, sort } = sortModel
  return [...rows]
    .sort((a, b) => {
      const aValue = a[field]
      const bValue = b[field]

      const aIsNil = aValue == null
      const bIsNil = bValue == null
      if (aIsNil && bIsNil) return 0
      if (aIsNil) return 1
      if (bIsNil) return -1

      if (aValue < bValue) return sort === 'asc' ? -1 : 1
      if (aValue > bValue) return sort === 'asc' ? 1 : -1
      return 0
    })
    .slice(0, limit)
}
